export default __webpack_public_path__ + "static/media/67.b9bd39a9.mp3";